
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grills-und-mehr",
      function () {
        return require("private-next-pages/grills-und-mehr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grills-und-mehr"])
      });
    }
  